import { useEffect, useState } from 'react';
import VConsole from 'vconsole';
import CryptoJS from 'crypto-js';
import _ from 'lodash';

function App() {
  // Get the hash part of the URL
  // const hash = window.location.hash;

  // Remove the '#' character
  // const queryString = hash.startsWith('#') ? hash.substring(1) : hash;
  // console.log(`queryString >>>>> `, queryString)

  const [telegramObj, setTelegramObj] = useState(null);

  const [initData, setInitData] = useState(null);
  const [user, setUser] = useState(null);
  const [userLocation, setUserLocation] = useState(null)


  
  // const [dataCheckString, setDataCheckString] = useState(null);
  // const [providedHash, setProvidedHash] = useState(''); // The 'hash' Telegram gave you

  // const [verificationHex, setVerificationHex] = useState(null)
  // const [verificationResult, setVerificationResult] = useState(null);

  // const [botToken, setBotToken] = useState("7663553407:AAFM8L8FLknZkuRkaSVxYD0xuhCdmMrMiyU");
  const [initData1, setInitData1] = useState(null);

  const botToken = '7663553407:AAEZibEv7IY8OxCWPXTr_26OmUdIJM0DoaY'
  const [result, setResult] = useState(null);

  // const [telegramObj, setTelegramObj] = useState(null)
  // const [telegramUser, setTelegramUser] = useState(null)

  // const [telegramObjKeys, setTelegramObjKeys] = useState(null)
  // const [allData, setAllData] = useState({})

  const vConsole = new VConsole();
  
  useEffect(() => {
    // Check if the Telegram object is available
    if (window.Telegram && window.Telegram.WebApp) {
      // For example, call the "ready" method to let Telegram know
      // your app is loaded and ready to interact.
      window.Telegram.WebApp.ready();
      console.log('Telegram WebApp is initialized!');

      try {
        setTelegramObj(window?.Telegram?.WebApp)
        console.log(`window.Telegram.WebApp.isFullscreen`, window.Telegram.WebApp.isFullscreen)
        if(!window.Telegram.WebApp.isFullscreen) {
          window.Telegram.WebApp.requestFullscreen()
        }

        // 1. Parse the 'initData' query string from Telegram
        //    This is the raw string in window.Telegram.WebApp.initData
        const rawInitData = window.Telegram?.WebApp?.initData;
        if (!rawInitData) {
          setResult('❌ No initData found in window.Telegram.WebApp');
          return;
        }

        console.log('Raw initData:', rawInitData);

        const params = new URLSearchParams(rawInitData);
        console.log('Parsed params:', Object.fromEntries(params.entries()));

        // params.set('user', encodeURIComponent(params.get('user')))
        // console.log('Params with user encodeURIComponent:', Object.fromEntries(params.entries()));
        // 2. Get the 'hash' (the signature from Telegram) and remove it
        const receivedHash = params.get('hash');
        params.delete('hash');

        // 3. If there's a 'signature' field, remove that too—Telegram typically uses 'hash'
        //    but some versions/apps may include 'signature'. It's NOT part of the data-check string.
        // if (params.has('signature')) {
        //  params.delete('signature');
        // }

        console.log('Received hash:', receivedHash);

        // 4. Sort the remaining keys alphabetically
        const sortedKeys = Array.from(params.keys()).sort();

        // 5. Build the data-check-string by "key=value" lines separated by '\n'
        //    IMPORTANT: do NOT modify the values (e.g., do not parse or stringify).
        const dataCheckString = sortedKeys
          .map((key) => `${key}=${params.get(key)}`)
          .join('\n');

        // If using Lodash trimEnd, you could do:
        // const cleanedDataCheckString = _.trimEnd(dataCheckString, '\n');
        // But it's typically not necessary. We'll just log dataCheckString directly:
        console.log('dataCheckString:', dataCheckString);

        // 6. Create the secret key via HMAC_SHA256(bot_token, key="WebAppData")
        const secretKeyWordArray = CryptoJS.HmacSHA256(botToken, 'WebAppData');
        const secretKeyHex = secretKeyWordArray.toString(CryptoJS.enc.Hex);

        console.log(`secretKeyWordArray: `,secretKeyWordArray)
        console.log('secretKeyHex:', secretKeyHex);

        // 7. Compute the HMAC of the data-check-string with that secret key
        const verificationWordArray = CryptoJS.HmacSHA256(dataCheckString, secretKeyWordArray);
        const calculatedHash = verificationWordArray.toString(CryptoJS.enc.Hex);

        console.log(`verificationWordArray: `, verificationWordArray)
        console.log('calculatedHash:', calculatedHash);
        console.log('receivedHash:', receivedHash);

        // 8. Compare calculated hash with the hash from Telegram
        const isValid = calculatedHash === receivedHash;
        setResult(isValid ? '✅ Data is valid' : '❌ Data is invalid');

        const initDataUnsafe = window.Telegram.WebApp.initDataUnsafe;
        if(initDataUnsafe) {
          setInitData(initDataUnsafe);
          console.log(`initDataUnsafe >>>>> `, initDataUnsafe)
          console.log('Set Init Data!');
        }
        if (initDataUnsafe?.user) {
          setUser(initDataUnsafe.user);
          console.log('Set User Data!');
        }
      }
      catch (err) {
        console.error(err)
      }
    }
  }, []);

  // useEffect(() => {
  //   console.log(`verificationHex >>>>> `, verificationHex)
  //   console.log(`providedHash >>>>> `, providedHash)
  //   // 3. Compare the calculated HMAC with the provided hash
  //   if (verificationHex === providedHash) {
  //     setVerificationResult(true);
  //   } else {
  //     setVerificationResult(false);
  //   }
  // }, [verificationHex, providedHash])

  const handleClose = () => {
    // If you want to close the Web App from the React component
    if (window.Telegram && window.Telegram.WebApp) {
      window.Telegram.WebApp.close();
    }
  };
  
  // useEffect(() => {
  //   // Parse tgWebAppData from the URL
  //   const urlParams = new URLSearchParams(queryString);
  //   // console.log(`urlParams.get('tgWebAppData') >>>>> `, urlParams.get(`tgWebAppData`))

  //   const tgWebAppData = urlParams.get('tgWebAppData');
  //   // console.log(`tgWebAppData >>>>> `, tgWebAppData)

  //   if (tgWebAppData) {
  //     try {
  //       // Decode and parse the data
  //       const decodedData = decodeURIComponent(tgWebAppData);
  //       // setTelegramData(decodedData);

  //       // console.log('Telegram Data:', decodedData);
  //       // setTelegramObj(decodedData)

  //       const urlParamsInside = new URLSearchParams(decodedData);
  //       // console.log(`urlParamsInside >>>>> `, urlParamsInside)

  //       let _keyList = [];
  //       for (const key of urlParamsInside.keys()) {
  //         console.log('Key:', key);
  //         _keyList.push(key)
  //       }

  //       setTelegramObj(urlParamsInside)
  //       setTelegramObjKeys(_keyList)


  //       // Optional: Log the user object
  //       if (urlParamsInside.get(`user`)) {
  //         // console.log('User:', JSON.parse(urlParamsInside.get(`user`)));
  //         setTelegramUser(JSON.parse(urlParamsInside.get(`user`)))
  //       }
  //     } catch (error) {
  //       console.error('Failed to parse tgWebAppData:', error);
  //     }
  //   }
  // }, [queryString]);

  // useEffect(() => {
  //   // console.log(`telegramObj >>>>> `, telegramObj)
  //   // console.log(`telegramObjKeys >>>>> `, telegramObjKeys)

  //   if(telegramObjKeys) {
  //     let objectData = {}
  //     for (let index = 0; index < telegramObjKeys.length; index++) {
  //       if(telegramObjKeys[index] !== 'user')
  //         objectData[telegramObjKeys[index]] = telegramObj.get(telegramObjKeys[index])
  //       else
  //         objectData[telegramObjKeys[index]] = JSON.parse(telegramObj.get(telegramObjKeys[index]))
  //     }

  //     // console.log(objectData)
  //     setAllData(objectData)
  //   }
  // }, [telegramObj, telegramObjKeys])




  // Function to get user location
  const requestLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          setUserLocation({ latitude, longitude });
          console.log('Location:', { latitude, longitude });
        },
        (error) => {
          console.error('Error getting location:', error);
        }
      );
    } else {
      console.error('Geolocation is not supported by this browser.');
    }
  };

  if (!user) {
    return <div>Loading user data...</div>;
  }

  return (
    <div>
      <h1>Telegram Mini App</h1>
      {initData && (
        <div>
          <h2>User Information</h2>
          <p>Value of window.Telegram.WebApp.isFullscreen: {telegramObj.isFullscreen ? "true" : "false"}</p>
          <p>Verification: {result}</p>
          <p>ID: {user?.id}</p>
          <p>Allows write to pm: {user?.allows_write_to_pm ? "true" : "false"}</p>
          <p>Name: {user?.first_name}</p>
          <p>Last Name: {user?.last_name}</p>
          <p>Username: {user?.username}</p>
          <p>Language Code: {user?.language_code}</p>
          <img src={user?.photo_url} alt={``} />
        </div>
      )}
      <button onClick={requestLocation}>Get Location</button>
      {userLocation && (
        <div>
          <h2>User Location</h2>
          <p>Latitude: {userLocation.latitude}</p>
          <p>Longitude: {userLocation.longitude}</p>
        </div>
      )}
    </div>
  );
}

export default App;
